import styles from './Privacy.module.css';

const Privacy = () => {
    return (
        <div className={styles.privacyWrap}>
            <h1>헤이파밍 개인정보처리방침</h1>
            <p className={styles.date}>시행일자: 2025년 10월 2일</p>

            <p>
                Spring Again(이하 "회사")은 이용자의 개인정보를 중요시하며, 「개인정보 보호법」 및 관련 법령을 준수합니다.
                회사는 헤이파밍 앱(이하 "앱")을 이용하는 과정에서 수집되는 개인정보를 다음과 같은 목적과 방식으로 처리합니다.
            </p>

            <h2>1. 수집하는 개인정보 항목</h2>
            <ul>
                <li>회원가입 시: 이메일 주소, 닉네임, 비밀번호(또는 소셜 로그인 정보)</li>
                <li>서비스 이용 시: 필지명, 작목명, 영농일지 내용, 업로드된 사진·영상·음성(STT 변환 텍스트 포함)</li>
                <li>자동 수집 정보: 기기 정보(운영체제, 단말기 모델명), 접속 로그, 쿠키, 이용 기록</li>
            </ul>

            <h2>2. 개인정보 수집 및 이용 목적</h2>
            <ul>
                <li>서비스 제공 및 유지·관리</li>
                <li>사용자 맞춤형 영농일지 기록 및 관리 기능 제공</li>
                <li>음성 인식(STT) 기능을 통한 편의성 제공</li>
                <li>고객 문의 응대 및 공지 전달</li>
                <li>보안, 불법 사용 방지 및 서비스 품질 개선</li>
                <li>법령에 따른 의무 이행 및 분쟁 해결</li>
            </ul>

            <h2>3. 개인정보 보유 및 이용기간</h2>
            <ul>
                <li>회원 탈퇴 시 즉시 파기</li>
                <li>관계 법령에 따라 일정 기간 보관이 필요한 경우에는 해당 법령에 따름</li>
                <li>계약·청약철회 관련 기록: 5년</li>
                <li>대금결제 및 재화 공급 관련 기록: 5년</li>
                <li>소비자 불만 및 분쟁 처리 기록: 3년</li>
            </ul>

            <h2>4. 개인정보의 제3자 제공 및 위탁</h2>
            <p>회사는 원칙적으로 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만, 서비스 제공을 위해 다음과 같이 외부 업체에 처리를 위탁할 수 있습니다.</p>
            <ul>
                <li>Firebase (Google LLC): 푸시 알림, 사용자 인증, 데이터 저장</li>
                <li>클라우드 서버 운영사 (예: AWS, Naver Cloud 등): 데이터 보관 및 서비스 운영</li>
            </ul>

            <h2>5. 개인정보 보호를 위한 안전성 확보 조치</h2>
            <ul>
                <li>개인정보 암호화 저장</li>
                <li>접근 권한 최소화 및 내부 보안 교육</li>
                <li>정기적인 보안 점검 및 서버 모니터링</li>
            </ul>

            <h2>6. 이용자의 권리</h2>
            <p>
                이용자는 언제든지 자신의 개인정보를 조회·수정·삭제·회원 탈퇴를 요청할 수 있습니다.
                요청은 앱 내 고객센터 또는 이메일을 통해 처리됩니다.
            </p>

            <h2>7. 개인정보 보호책임자</h2>
            <p>
                이름: 정찬훈 <br />
                소속: Spring Again <br />
                이메일: springagain2025@gmail.com <br />
                연락처: 010-2868-0655
            </p>

            <h2>8. 변경 사항 고지</h2>
            <p>
                본 개인정보처리방침이 변경될 경우 앱 내 공지사항을 통해 사전 고지합니다.
            </p>
        </div>
    );
};

export default Privacy;
